import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import TxTable from '../components/tx_table'

const UserTransactions = ({ isAuthenticated, isTokenExpired }) => (
  <>{isAuthenticated && !isTokenExpired && <TxTable />}</>
)

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.auth.errorMessage,
  isTokenExpired: state.auth.isTokenExpired,
})

export default withRouter(connect(mapStateToProps)(UserTransactions))
